import _ from 'lodash';
import { initSentry, } from '../libs/sentry';
import { install as PermissionPlugin, } from '../plugins/permission/index';
export function configPermission(options) {
    const { Vue, store, systemService, authService, } = options;
    // Persmission 相当于PermissionPlugin.install(Vue,{//...})
    Vue.use(PermissionPlugin, {
        store,
        debug: systemService.Permission,
        whiteListCheck(p) {
            if (!authService.currentUser) {
                return false;
            }
            const email = authService.currentUser.email;
            if (_.includes(['ConfigList'], p)) {
                if (_.includes([
                    'caoyuan@patsnap.com',
                    'wangxinbo@patsnap.com',
                    'guyong@patsnap.com',
                    'cuilili@patsnap.com',
                    'zhaochenfei@patsnap.com',
                    'zhangxin@patsnap.com',
                    'huangqing@patsnap.com',
                    'liuxuyang@patsnap.com',
                    'jiangqinjuan@patsnap.com',
                    'wangmenghuan@patsnap.com',
                    'yudaofang@patsnap.com'
                ], email)) {
                    return true;
                }
            }
            if (_.includes(['postman'], p)) {
                if (_.includes([
                    'lizhi@patsnap.com',
                    'zhourui@patsnap.com',
                    'zhangxin@patsnap.com',
                    'wangyulong@patsnap.com',
                    'liujiawei@patsnap.com',
                    'donghao@patsnap.com',
                    'wangmenghuan@patsnap.com',
                    'yanglinlin@patsnap.com',
                    'chenghaiyang@patsnap.com',
                    'cuilili@patsnap.com',
                    'zhaochenfei@patsnap.com'
                ], email)) {
                    return true;
                }
            }
        },
    });
    // 监听用户信息,更新权限
    authService.currentUser$.subscribe(info => {
        if (info) {
            Vue.updatePermissions(info);
        }
        else {
            // 标志初始化false
            systemService.Init = false;
        }
        initSentry(info);
    });
    authService.currentUserDataResource$.subscribe(data => {
        Vue.updateDataPermissions(data);
    });
}
